import { LAYOUTS, } from '@voltmoney/types';
import { WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { getLenderInfo, getParameters, horizontalStepperRepo, isFromJupiter, removeURLParams } from '../../../configs/utils';
import { contactUs, digioAgreementDeepCallAction, emptyAction, goBack, initAction, initActionForAndroid, moveToNextStepAction, retryAgreementHidePopup } from './actions';
import SharedPropsService from '../../../SharedPropsService';
import { failedVerification, successVerification, } from '../../kyc/kyc_init/actions';
import { Platform } from "react-native";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
const url = Platform.OS === 'web' ? window?.location?.href : '';
const params = Platform.OS === 'web' ? getParameters(url) : {};
const digio_agreement_response = params?.digio_agreement_response;
export const template = (stepper, height, digio_agreement_response, digio_status, lenderInfo, isJupiter, apiFailureCard, loading) => ({
    layout: {
        id: ROUTE.DIGIO_AGREEMENT_SIGN,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: 'DigioAgreementPage', type: WIDGET.DIGIO_AGREEMENT_PAGE
            }
        ],
    },
    datastore: {
        DigioAgreementPage: {
            height: height,
            digio_agreement_response: digio_agreement_response,
            digio_status: digio_status,
            continueAction: {
                routeId: ROUTE.DIGIO_AGREEMENT_SIGN,
                type: ACTION.INIT_DOCS,
                payload: {}
            },
            digioAgreementDeepCheckAction: {
                routeId: ROUTE.DIGIO_AGREEMENT_SIGN,
                type: ACTION.AGREEMENT_DEEP_CALL,
                payload: {}
            },
            hidePopUpAction: {
                routeId: ROUTE.DIGIO_AGREEMENT_SIGN,
                type: ACTION.RETRY_AGREEMENT_HIDE_POPUP,
                payload: {}
            },
            proceedToNextAction: {
                routeId: ROUTE.DIGIO_AGREEMENT_SIGN,
                type: ACTION.MOVE_TO_NEXT_STEP,
                payload: {}
            },
            contactUsAction: {
                routeId: ROUTE.DIGIO_AGREEMENT_SIGN,
                type: ACTION.NAV_CONTACT_US,
                payload: {}
            },
            lenderInfo: lenderInfo,
            stepperProps: stepper,
            isJupiter: isJupiter,
            apiFailureCard: apiFailureCard,
            loading: params?.digio_agreement_response || loading ? true : false,
            backAction: params?.digio_agreement_response ? {
                routeId: ROUTE.DIGIO_AGREEMENT_SIGN,
                type: ACTION.GO_BACK,
                payload: {}
            } : {
                routeId: ROUTE.DIGIO_AGREEMENT_SIGN,
                type: ACTION.EMPTY_ACTION,
                payload: {}
            }
        }
    },
});
export const digioAgreementSignMF = {
    onLoad: async ({ network, getHeight, setDatastore }, { apiFailureCard, setIsUserLoggedIn, loading }) => {
        const userResponse = await network.post(api.userContext, {}, {
            headers: await getAppHeader(),
        });
        await SharedPropsService.setUser(userResponse.data);
        const url = Platform.OS === 'web' ? window.location.href : '';
        const params = Platform.OS === 'web' ? getParameters(url) : {};
        const digio_agreement_response = params?.digio_agreement_response;
        const digio_status = params?.status;
        const lenderInfo = await getLenderInfo(network);
        const stepper = await horizontalStepperRepo(network);
        setIsUserLoggedIn(userResponse.data);
        const isJupiter = await isFromJupiter();
        if (Platform.OS === "web") {
            if (digio_agreement_response) {
                await setDatastore(ROUTE.DIGIO_AGREEMENT_SIGN, "DigioAgreementPage", {
                    loading: true
                });
                removeURLParams();
            }
            else {
                setTimeout(() => {
                    setDatastore(ROUTE.DIGIO_AGREEMENT_SIGN, "DigioAgreementPage", {
                        loading: false
                    });
                }, 0);
            }
        }
        return Promise.resolve(template(stepper, getHeight(), digio_agreement_response, digio_status, lenderInfo, isJupiter, apiFailureCard, loading));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.INIT_DOCS]: Platform.OS !== 'web' ? initActionForAndroid : initAction,
        [ACTION.FAILED_VERIFICATION]: failedVerification,
        [ACTION.SUCCESS_VERIFICATION]: successVerification,
        [ACTION.AGREEMENT_DEEP_CALL]: digioAgreementDeepCallAction,
        [ACTION.RETRY_AGREEMENT_HIDE_POPUP]: retryAgreementHidePopup,
        [ACTION.MOVE_TO_NEXT_STEP]: moveToNextStepAction,
        [ACTION.NAV_CONTACT_US]: contactUs,
        [ACTION.EMPTY_ACTION]: emptyAction
    },
};
